export const routingConstants = {
  overview: '/overview',
  facility: '/facility',
  equipment: '/equipment',
  adminTool: '/admin-tool',
  helpSupport: '/help-support',
  auth: '/auth',
  profile: '/profile',
  alert: '/alerts',
  recoveryPassword: '/auth/recovery-password',
  recoveryPasswordSentEmail: '/auth/recovery-password-sent-email',
  confirmRestoreCode: '/auth/confirm-restore-code',
  confirmRestorePassword: '/auth/confirm-restore-password',
  errorRestorePassword: '/auth/error-restore-password',
  successRestorePassword: '/auth/success-restore-password',
  devicesManagement: '/devices-management',
  devicesConnection: '/device-connection',
  panelsManagement: '/panels-management',
}
